import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { DropDownInterval } from 'src/app/data-models/common/drop-down-interval.model';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Component({
	selector: 'vtr-ui-dropdown',
	templateUrl: './ui-dropdown.component.html',
	styleUrls: ['./ui-dropdown.component.scss'],
})
export class UiDropDownComponent implements OnInit, OnChanges {
	@Input() dropDownId: string;
	@Input() dropDownName: string;
	@Input() list: DropDownInterval[];
	@Input() value: number;
	@Input() disabled = false;
	@Input() textCase: string;
	@Input() notSelectedValue: { name?: string; text?: string; placeholder?: string };

	@Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();

	iconUp = faChevronUp;
	iconDown = faChevronDown;
	isDropDownOpen = false;
	name: string;
	placeholder: string;
	narratorLabel: string;
	selectedValue: number;
	applyHoverClass: boolean;
	applyFocusClass: boolean;

	constructor(private logger: LoggerService) {}

	ngOnInit() {
		this.setDropDownValue();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (
			changes &&
			changes.value &&
			changes.value.previousValue !== changes.value.currentValue
		) {
			this.setDropDownValue();
		}
	}

	// refactoring duplicate lines of code for interval
	settingDimmerIntervals(interval) {
		this.selectedValue = this.list.indexOf(interval);
		this.name = interval.name;
		this.placeholder = interval.placeholder || interval.text;
		this.narratorLabel = interval.text;
	}

	// checks for any previous selected value if any; if no value then calls 'setDropDropValue method
	setDropDownValue() {
		if (this.value !== undefined && this.list) {
			const itemValue = this.list.find((item) => item.value === this.value);
			if (itemValue) {
				this.settingDimmerIntervals(itemValue);
			}
		} else {
			this.setDefaultDropValue();
		}
	}

	// sets 'select-time' or 'please-select'
	setDefaultDropValue() {
		this.name = this.notSelectedValue.name;
		this.placeholder = this.notSelectedValue.placeholder || this.notSelectedValue.text;
		this.narratorLabel = `${this.name}-${this.placeholder}`;
	}

	// toggles dropdown-list when we click on chevron icon
	toggleList(event) {
		event.stopPropagation();
		if (!this.disabled) {
			this.isDropDownOpen = !this.isDropDownOpen;
			this.applyFocusClass = false;
		}
	}

	// Below method is triggered from directive to close the dropdown list and set the change in interval if any.
	closeDropdown(event) {
		try {
			const value = this.list.find((item, idx) => idx === event.value);
			this.isDropDownOpen = event.hideList;
			this.settingDimmerIntervals(value);
			this.selectionChange.emit(value);
		} catch (error) {
			this.logger.error('Error', error);
		}
	}
}
